import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import VerificationPage from './components/VerificationPage';
import RegisterPage from './components/RegisterPage';
import VerifiedAccountPage from './components/VerifiedAccountPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import PasswordResetSentPage from './components/PasswordResetSentPage';
const mockUsers = [{
  email: 'verified@example.com',
  password: 'password123',
  verified: true
}, {
  email: 'unverified@example.com',
  password: 'password123',
  verified: false
}];
export function App() {
  const [currentEmail, setCurrentEmail] = useState('');
  useEffect(() => {
    document.title = 'Improve Register';
  }, []);
  const isEmailRegistered = email => {
    return mockUsers.some(user => user.email === email);
  };
  const isEmailVerified = email => {
    const user = mockUsers.find(user => user.email === email);
    return user ? user.verified : false;
  };
  const validateLogin = (email, password) => {
    const user = mockUsers.find(user => user.email === email && user.password === password);
    if (user) {
      if (user.verified) {
        return {
          success: true,
          message: 'Login successful'
        };
      } else {
        return {
          success: false,
          message: 'Email not verified',
          needsVerification: true
        };
      }
    }
    return {
      success: false,
      message: 'Invalid email or password'
    };
  };
  return <Router data-id="element-0">
      <div className="min-h-screen bg-blue-50" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LoginPage validateLogin={validateLogin} setCurrentEmail={setCurrentEmail} data-id="element-4" />} data-id="element-3" />
          <Route path="/register" element={<RegisterPage isEmailRegistered={isEmailRegistered} isEmailVerified={isEmailVerified} setCurrentEmail={setCurrentEmail} data-id="element-6" />} data-id="element-5" />
          <Route path="/verify" element={<VerificationPage email={currentEmail} data-id="element-8" />} data-id="element-7" />
          <Route path="/verified" element={<VerifiedAccountPage data-id="element-10" />} data-id="element-9" />
          <Route path="/forgot-password" element={<ForgotPasswordPage isEmailRegistered={isEmailRegistered} setCurrentEmail={setCurrentEmail} data-id="element-12" />} data-id="element-11" />
          <Route path="/password-reset-sent" element={<PasswordResetSentPage data-id="element-14" />} data-id="element-13" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-16" />} data-id="element-15" />
        </Routes>
      </div>
    </Router>;
}
export default App;